export default __webpack_public_path__ + "static/media/mini_white.9af2e5bb.png";